var pageSlider,
	navItems,
	$video;
$(function(){
	$video = document.getElementById('videoMain');
	if($(window).width() >= $(window).height()){
		pageSlider = $('#window').flickity({
			cellSelector:'section.gbl',
			pageDots:false,
			cellAlign:'left',
			prevNextButtons:false,
			contain:true,
			freeScroll:false,
			wrapAround:false,
			draggable:false,
			imagesLoaded:false,
			selectedAttraction: 0.04,
			friction: 0.6,
		});
		pageSlider.on('select.flickity',function(event, index){
			var index = $('.is-selected').index();
			if(index > 0){
				$('.nav-gbl').addClass('is-home');
			} else{
				$('.nav-gbl').removeClass('is-home');
			}
			$('.nav-gbl').removeClass('is-smol');
			if(index == 1){
				$('.nav-gbl').addClass('is-smol');
			}
		})
		setTimeout(function(){
			$('body').addClass('wobble');
		},500);
		// NAV
		navItems = $('.navel-link');
		navItems.click(function(event){
			event.preventDefault();
			var target = $(this).attr('href');
			var el = $(target).index();
			pageSlider.flickity('select',el);
			if(target == '#watch'){
				$video.currentTime = 0;
				var switchToVideo;
				clearTimeout(switchToVideo);
				switchToVideo = setTimeout(function(){
					$video.play()
				},800)
			} else{
				$video.pause()
			}
		});
		$('.video-bg').click(function(){
			navItems.filter('[href="#watch"]')[0].click();
		})
	}
})